import Base from 'core/pages/SimpleReadingList/SimpleReadingListStart'
import { Routes } from 'custom/louis-vuitton/pages'
import { Router } from 'stylewhere/shared'

export default class SimpleReadingListStart extends Base {
  isOneIDTable =
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.operation.attributes['isOneIDTable'] && this.operation.attributes['isOneIDTable'] === 'true'

  oneIDTablePath: Routes = '/oneIDTable'

  async componentDidMount() {
    if (this.isOneIDTable) {
      Router.navigate(this.oneIDTablePath as any)
    }
  }

  public render() {
    return this.isOneIDTable ? <div /> : super.render()
  }
}
